module.exports = __webpack_public_path__ + "static/media/ic_04_security.0c288bdd.svg";